import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d6dn9biff40lgbk6dh0g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus('idle'), 3000);
    }
  };

  return (
    <footer className="bg-gray-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="world-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="50" cy="50" r="1" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#world-pattern)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12 sm:mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/35af317c-ff06-4831-b241-787dd1236a773.png" 
              alt="EVENTSHOWCASE" 
              className="h-10 sm:h-12 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 mb-6">
              Where events meet social growth
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-lg hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600 hover:border-transparent transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-lg hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600 hover:border-transparent transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-lg hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600 hover:border-transparent transition-all cursor-pointer"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-lg hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600 hover:border-transparent transition-all cursor-pointer"
              >
                <i className="ri-linkedin-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-bold mb-4">Discover</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/events" className="hover:text-white transition-colors">Browse Events</Link></li>
              <li><Link to="/events/free" className="hover:text-white transition-colors">Free Events</Link></li>
              <li><Link to="/events/this-weekend" className="hover:text-white transition-colors">This Weekend</Link></li>
              <li><Link to="/categories" className="hover:text-white transition-colors">Categories</Link></li>
              <li><Link to="/how-it-works" className="hover:text-white transition-colors">How It Works</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-bold mb-4">Create</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/create-event" className="hover:text-white transition-colors">List Event</Link></li>
              <li><Link to="/subscribe" className="hover:text-white transition-colors">Pricing</Link></li>
              <li><Link to="/creator-guide" className="hover:text-white transition-colors">Creator Guide</Link></li>
              <li><Link to="/success-stories" className="hover:text-white transition-colors">Success Stories</Link></li>
              <li><Link to="/resources" className="hover:text-white transition-colors">Resources</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm sm:text-base font-bold mb-4">Stay Updated</h4>
            <p className="text-sm text-gray-400 mb-4">Get weekly event picks</p>
            <form id="newsletter-form" data-readdy-form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                required
                className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:border-purple-500 transition-colors"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-5 py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all whitespace-nowrap disabled:opacity-50"
              >
                {isSubmitting ? 'Sending...' : 'Subscribe'}
              </button>
            </form>
            {submitStatus === 'success' && (
              <p className="text-green-400 text-xs mt-2">Successfully subscribed!</p>
            )}
            {submitStatus === 'error' && (
              <p className="text-red-400 text-xs mt-2">Something went wrong. Please try again.</p>
            )}
          </div>
        </div>

        <div className="pt-6 sm:pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500">
          <p className="text-center sm:text-left">&copy; 2025 EVENTSHOWCASE. All rights reserved.</p>
          <div className="flex items-center gap-3 sm:gap-4 flex-wrap justify-center">
            <Link to="/legal/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <span>•</span>
            <Link to="/legal/terms" className="hover:text-white transition-colors">Terms</Link>
            <span>•</span>
            <Link to="/legal/refund-policy" className="hover:text-white transition-colors">Refund &amp; Tax Policy</Link>
            <span>•</span>
            <Link to="/legal/cookies" className="hover:text-white transition-colors">Cookie Policy</Link>
          </div>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
